import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Welcome from './views/Welcome.vue';
import Login from './views/user/Login.vue';
import Buttons from './views/device/Buttons.vue';
import Devices from './views/device/Devices.vue';
import Tiles from './views/device/Tiles.vue';
import Floorplan from './views/device/Floorplan.vue';
import Settings from './views/device/Settings.vue';
import Wifi from './views/device/Wifi.vue';
import ForgottenPassword from './views/user/ForgottenPassword.vue';
import ChangePassword from './views/user/ChangePassword.vue';
import CreateUser from './views/user/CreateUser.vue';
import Debug from './views/Debug.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/welcome',
    },
    { path: '/welcome', name: 'welcome', component: Welcome },
    { path: '/login', component: Login },
    { path: '/user/forgotten-password', component: ForgottenPassword },
    { path: '/user/change-password', component: ChangePassword },
    { path: '/user/create', component: CreateUser },
    { path: '/devices', component: Devices },
    { path: '/buttons/:deviceNumber', component: Buttons, props: true },
    { path: '/floorplan/:deviceNumber', component: Floorplan, props: true },
    { path: '/tiles/:deviceNumber', component: Tiles, props: true },
    { path: '/settings/:deviceNumber', component: Settings, props: true },
    { path: '/settings/wifi/:deviceNumber', component: Wifi, props: true },
    { path: '/debug/:deviceNumber', component: Debug, props: true },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
  ],
});
